const normalizeDocumentTypeValue = (raw) => {
  if (typeof raw === "string") {
    const normalized = raw.trim().toLowerCase();
    if (["purchase", "sale", "return", "credit", "other"].includes(normalized)) {
      return normalized === "credit" ? "return" : normalized;
    }
  }
  return null;
};

const hasFlag = (source, key) => {
  if (!source || typeof source !== "object") return false;
  return Boolean(source[key]);
};

export const resolveDocumentType = (doc) => {
  if (!doc || typeof doc !== "object") return null;

  if (hasFlag(doc, "is_return")) return "return";
  if (hasFlag(doc, "is_sale")) return "sale";
  if (hasFlag(doc, "is_other")) return "other";

  return normalizeDocumentTypeValue(doc.document_type || doc.type || doc.documentType);
};

export const getDocumentTypeMeta = (doc, t, options = {}) => {
  const type = resolveDocumentType(doc);
  if (!type || type === "purchase") return null;

  const { fallbackLabels = {} } = options;

  const defaultLabels = {
    sale: "Pardavimo dokumentas",
    return: "Grąžinimo dokumentas",
    other: "Kitas dokumentas",
  };

  const translationKeyMap = {
    sale: "salesDocument",
    return: "returnDocument",
    other: "otherDocument",
  };

  const translatedLabel = (() => {
    if (!t) return null;
    const key = translationKeyMap[type];
    if (!key) return null;
    const candidate = t(key);
    return candidate && candidate !== key ? candidate : null;
  })();

  const label = translatedLabel || fallbackLabels[type] || defaultLabels[type];

  const chipColorMap = {
    sale: "warning",
    return: "error",
    other: "secondary",
  };

  return {
    type,
    label,
    chipColor: chipColorMap[type] || "default",
    chipVariant: type === "other" ? "outlined" : "filled",
  };
};
